import React, { createContext, useContext } from 'react';
// Unica sede dell'import del foglio v4: lo usano le tre pagine del Centro
// Ticket (admin e rappresentante) tramite questo modulo. Tutti i selettori sono
// sotto `.sup4`, quindi con il look 'v3' il foglio non ha effetto.
// Il foglio v3 va importato PRIMA: molte regole v4 hanno la stessa specificità
// delle v3 (`.sup4 .x` vs `.sup3 .x`) e vince l'ultima nel bundle. Senza questo
// ordine, in produzione la bolla della risposta restava chiara con testo bianco.
import '../../../styles/support-v3.css';
import '../../../styles/support-v4.css';

/**
 * Veste del Centro Ticket (redesign v4, strategia C «pelle opt-in»).
 * 'v3' = la pagina di oggi; 'v4' = pelle v4 accesa per chi ha il permesso
 * `supporttickets.v4_preview` (admin) o `associativa.supporto.v4_preview`
 * (rappresentante). Il default e 'v3': senza provider nulla cambia.
 */
export type SupportLook = 'v3' | 'v4';

export const SUPPORT_LOOKS: readonly SupportLook[] = ['v3', 'v4'];

const SupportLookContext = createContext<SupportLook>('v3');

export const SupportLookProvider: React.FC<{ look: SupportLook; children: React.ReactNode }> = ({ look, children }) => (
  <SupportLookContext.Provider value={look}>{children}</SupportLookContext.Provider>
);

/** Veste corrente: i componenti la leggono senza cambiare le loro props. */
export const useSupportLook = (): SupportLook => useContext(SupportLookContext);

/**
 * Il flag di anteprima va letto dalla LISTA dei permessi, non da
 * `hasPermission()`: quello risponde sempre true al ruolo admin
 * (`usePermissions`/`AuthContext`), che accenderebbe il v4 a tutti gli
 * amministratori senza che nessuno l'abbia assegnato.
 */
export const hasExplicitPermission = (
  permissions: ReadonlyArray<{ name?: string }> | null | undefined,
  name: string
): boolean => !!permissions?.some((p) => p.name === name);

/** Classe della radice: aggiunge `sup4` solo in v4 (con 'v3' la stringa resta identica). */
export const supportRootClass = (base: string, look: SupportLook): string =>
  look === 'v4' ? `${base} sup4` : base;
